export const CONFIGS = {
  EXTEND_SESSION_TIMER: 900000, // 15 mins
  EXPIRED_SESSION_TIMER: 1200000, // 20 mins
  UIAM_EXPIRE_SESSION_TIMER: 1800000, // 30 mins
  TAGS: {
    COLLECT_AT_STORE: 'singtel:eshop-delivery/collect-at-store',
    POP_STATION: 'singtel:eshop-delivery/pop-station',
    ACCESSORY_CATEGORY: 'singtel:all-accessory-deals/',
    MAIN_PRODUCT_CATEGORY: 'singtel:product-categories/'
  },
  REQUEST_CODES: {
    GATE_REDIRECT_SUCCESS: 'GATESVC_302',
    GATE_REDIRECT_OUTAGE: 'GATESVC_500',
    ONEPASS_INVALID: 'ONEPASS_INVALID'
  },
  YUU_MEMBERSHIP_CODE: 'yuu',
  SPECIAL_PROMOTE_NO_CODES: [], // remove all items for now cuz all special plans need to apply promo
  CUSTOM_404_IMAGES: {
    MOBILE:
      'https://www.singtel.com/content/dam/singtel/eshop/Mobile/detox/holding-page/Detox/iPhone15-waiting-room-detox-banner-1280X750.jpg',
    DESKTOP:
      'https://www.singtel.com/content/dam/singtel/eshop/Mobile/detox/holding-page/Detox/iPhone15-waiting-room-detox-banner-2500X720.jpg'
  },
  IMEI_LENGTH: 15,
  ACCESSORIES_LIMIT: 100 // show all accessories configured from AEM
};

export enum AEM_CONFIG_KEYS {
  DETOX_RRP_IPP_NOT_ELIGIBLE_PLANS = 'DETOX_RRP_IPP_NOT_ELIGIBLE_PLANS',
  DETOX_ENABLE_RRP_PRICE_SLASH = 'DETOX_ENABLE_RRP_PRICE_SLASH',
  DETOX_RRP_PROMO_STRIP = 'DETOX_RRP_PROMO_STRIP',
  DETOX_ADDONS_SOP_GROUP_NAME = 'DETOX_ADDONS_SOP_GROUP_NAME',
  DETOX_BIB_TNC = 'DETOX_BIB_TNC',
  DETOX_BIB_DEVICE_GROUP_ID = 'DETOX_BIB_DEVICE_GROUP_ID',
  DETOX_SHOPPING_CART_REMOVE_ADDON_IDS = 'DETOX_SHOPPING_CART_REMOVE_ADDON_IDS',
  DETOX_CIS_MYINFO_CHANGE_SKIP_DOC_UPLOAD = 'DETOX_CIS_MYINFO_CHANGE_SKIP_DOC_UPLOAD',
  SPECIAL_PROMO_SALE = 'SPECIAL_PROMO_SALE',
  DETOX_DISABLE_ESIM_SOP_RECON = 'DETOX_DISABLE_ESIM_SOP_RECON',
  DETOX_ENABLE_PD_CARDS_SWIMLANE_VIEW = 'DETOX_ENABLE_PD_CARDS_SWIMLANE_VIEW',
  DETOX_SKIP_ADDONS_FOR_PLANS = 'DETOX_SKIP_ADDONS_FOR_PLANS',
  DETOX_NETWORK_SPEED_MAP = 'DETOX_NETWORK_SPEED_MAP',
  DETOX_DEFAULT_PLANS = 'DETOX_DEFAULT_PLANS',
  DETOX_SEND_OTP_PMX_PENTEST_FIX = 'DETOX_SEND_OTP_PMX_PENTEST_FIX',
  DETOX_ACCESSORIES_FOR_SHOPPING_CART = 'DETOX_ACCESSORIES_FOR_SHOPPING_CART',
  DETOX_SPECIAL_PROMO_HIDE_PORTIN = 'DETOX_SPECIAL_PROMO_HIDE_PORTIN',
  DETOX_PX_BCC_ADDONS_MAPPER = 'DETOX_PX_BCC_ADDONS_MAPPER',
  DETOX_PX_ADDONS_ENABLED = 'DETOX_PX_ADDONS_ENABLED',
  DETOX_WORRYFREE_RECAPTCHA_SITE_KEY = 'DETOX_WORRYFREE_RECAPTCHA_SITE_KEY',
  NUMBER_POOL_LOCK_DURATION = 'NUMBER_POOL_LOCK_DURATION',
  NUMBER_POOL_LINES_COUNT = 'NUMBER_POOL_LINES_COUNT'
}

export type VARIABLE_CONFIG_NAMES = keyof typeof AEM_CONFIG_KEYS;

export const CP_ERROR_CODES = {
  CREDIT_LIMIT_UNSUCCESS: '50021',
  CREDIT_LIMIT_REVIEW: '50023'
};

export const CREDIT_LIMIT_FLOWTYPE = 'detoxMobile';

export const URL_PARAMS_MAPPING = {
  phones: 'singtel:instalment-options/ipp-phones',
  'life-style': 'singtel:all-mobile-deals/lifestyle-products',
  'sim-only-plus-plan-with-singtel-paylater':
    'singtel:instalment-options/ipp-phones',
  '0percent-interest-instalment-plan': 'singtel:instalment-options/ipp-phones'
};

export const BE_ERROR_INFO = {
  ORDER_SUBMITTED: '[Order already submitted.]'
};
